// key-storage-native.service.ts
import { Injectable } from "@angular/core";
import { Preferences } from "@capacitor/preferences";
import { IKeyStorage } from "../crypto/key-manager";
import { Securekey } from "secure-key-plugin";

@Injectable()
export class KeyStorageNativeService implements IKeyStorage {
  private readonly WRAPPED_KEY = "wrapped_aes_key";

  async saveWrappedKey(wrappedKeyB64: string): Promise<void> {
    try {
      await Securekey.secureSet({
        key: this.WRAPPED_KEY,
        valueB64: wrappedKeyB64,
      });
      //console.log("✅ Wrapped key saved (native)");
    } catch (e) {
      console.error("❌ saveWrappedKey failed:", e);
      throw e; // re-throw so caller knows it failed
    }
  }

  async getWrappedKey(): Promise<string | null> {
   // console.log("getWrappedKey entered");
    try {
      const result = await Securekey.secureGet({ key: this.WRAPPED_KEY });
     // console.log("result getWrappedKey", result);
      const value = result?.valueB64 ?? null;
     // console.log("value getWrappedKey", value);
      return value;
    } catch (e) {
      // Key doesn't exist yet or storage was reset - treat as null
      console.warn("getWrappedKey: key not found or storage reset:", e);
      return null;
    }
  }

  async deleteWrappedKey(): Promise<void> {
    await Securekey.secureDelete({ key: this.WRAPPED_KEY });
    //  console.log('🗑️ Wrapped key deleted (native)');
  }
  async savePrivateKey(_privateKey: CryptoKey): Promise<void> {
    // No-op on native – RSA private key is in Keystore
    console.warn(
      "savePrivateKey(native): no-op, private key lives in Keystore.",
    );
  }

  async getPrivateKey(): Promise<CryptoKey | null> {
    // Private key is not accessible on native – plugin uses it internally
    console.warn(
      "getPrivateKey(native): always null, private key lives in Keystore.",
    );
    return null;
  }

  async savePublicKey(_publicKey: CryptoKey): Promise<void> {
    // Optionally store SPKI string somewhere else, but not needed for native path
    console.warn(
      "savePublicKey(native): no-op, use SPKI string + plugin keypair.",
    );
  }

  async getPublicKey(): Promise<CryptoKey | null> {
    console.warn("getPublicKey(native): not used on native.");
    return null;
  }
  async clear(): Promise<void> {
    await this.deleteWrappedKey();
    //  console.log('🔄 Keys cleared (native): wrapped key removed');
  }
}
